import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function equipments(state = initialState.equipments, action) {
    switch (action.type) {

        case types.LOAD_EQUIPMENT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            })
        case types.LOAD_EQUIPMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: action.data
            })
        case types.LOAD_EQUIPMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.LOAD_MORE_EQUIPMENT_REQUEST:
            return Object.assign({}, state, {
                isFetchingMore: true
            })
        case types.LOAD_MORE_EQUIPMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetchingMore: false,
                errorMessage: '',
                data: {
                    ...state.data,
                    ...action.data,
                    results: [
                        ...state.data.results,
                        ...action.data.results
                    ]
                }
            })
        case types.LOAD_MORE_EQUIPMENT_FAILURE:
            return Object.assign({}, state, {
                isFetchingMore: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.CREATE_EQUIPMENT_REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            })
        case types.CREATE_EQUIPMENT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: {
                    ...state.data,
                    results: [
                        ...state.data.results,
                        action.data
                    ]
                }
            })
        case types.CREATE_EQUIPMENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.DELETE_EQUIPMENT_REQUEST:
            return Object.assign({}, state, {
                isDeleting: true
              //  isFetching: true
            })
        case types.DELETE_EQUIPMENT_SUCCESS:
            let newState = state.data.results.filter(equipment => 
                equipment.id !== action.data.id
            );

            return Object.assign({}, state, {
                isDeleting: true,
                //isFetching: false,
                errorMessage: '',
                data: {
                    ...state.data,
                    results: [
                        ...newState
                    ]
                }
            })
        case types.DELETE_EQUIPMENT_FAILURE:
            return Object.assign({}, state, {
                isDeleting: false,
             //   isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.UPDATE_EQUIPMENT_REQUEST:
            return Object.assign({}, state, {
                isUpdating: true
            })
        case types.UPDATE_EQUIPMENT_SUCCESS:
            let newResults = Object.assign([], state.data.results);

            const indexToUpdate = state.data.results.findIndex(equipment =>
                equipment.id == action.data.id
            );

            newResults.splice(indexToUpdate, 1, action.data);

            return Object.assign({}, state, {
                isUpdating: false,
                errorMessage: '',
                data: {
                    ...state.data,
                    results: [
                        ...newResults
                    ]
                }
            })
        case types.UPDATE_EQUIPMENT_FAILURE:
            return Object.assign({}, state, {
                isUpdating: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.RESET_ALL_INFO:
            return initialState.equipments

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/equipmentReducer.js